const loadInitialState = () => {
  return App.shop ?
    { 
      id: App.shop.id,
      shopType: App.shop.shop_type,
      showTouchless: App.shop.touchless_payments,
      zellePayments: App.shop.zelle_payments,
      showDiscountPerItem: App.shop.discount_per_item,
      socketUrl: App.socketUrl,
      locationId: App.locationId,
      currency: App.shop.currency,
      stripe: App.shop.stripe && { ...App.shop.stripe, m2Connected: false }
    } : {}
}

const changeShop = (state, id, shopType, location, stripeLocation, currency, account) => (
  {
    id: id, 
    shopType: shopType,
    showTouchless: state.showTouchless,
    zellePayments: state.zellePayments,
    showDiscountPerItem: state.showDiscountPerItem,
    paymentProcessor: state.paymentProcessor,
    socketUrl: state.socketUrl,
    locationId: location,
    currency: currency,
    stripe: state.stripe && {...state.stripe, location: stripeLocation, account: account, m2Connected: false}
  }
)

const shopEntity = (state = {}, action) => {
  switch (action.type) {
    case 'SHOP.INIT':
    case 'SHOP_INVENTORY.INIT':
    case 'PAYMENT_MODAL.INIT':
      return loadInitialState();
    case 'SHOP_CHANGE':
      return changeShop(state, action.id, action.shopType, action.location, action.stripeLocation, action.currency, action.account)
    case 'M2.CONNECTION_STATUS':
      return {...state, stripe: {...state.stripe, m2Connected: action.payload}}
    default:
      return state
  }
}

export default shopEntity;
